import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Typography,
  Popover,
  Avatar,
  Button,
  Divider,
  Badge,
} from '@mui/material';
import './Notifications.scss';
import IconNotification from '../../assets/icons/IconNotification';
import CircleIcon from '@mui/icons-material/Circle';
import IconSecAI from '../../assets/icons/IconSecAI';

const notifications = [
  {
    id: 1,
    title: 'Agent Loan Tape Ingestion and Standardization finished processing.',
    time: '5 hours ago',
    unread: true,
  },
  {
    id: 2,
    title: 'Agent Loan Pricing and Valuation successfully scheduled.',
    time: 'July 14, 2025 • 06:10 PM',
    unread: true,
  },
  {
    id: 3,
    title: 'Agent Loan Tape Ingestion and Standardization skipped 124 rows due to invalid format.',
    time: 'July 16, 2025 • 09:10 AM',
    unread: true,
  },
];

const Notifications = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;

  return (
    <>
      <Box className='notification'>
        <IconButton color='inherit' className='btn-notification' onClick={handleClick}>
          <Badge badgeContent={notifications.filter((n) => n.unread).length} color='primary'>
            <IconNotification width={40} height={40} />
          </Badge>
        </IconButton>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              maxWidth: { xs: '320px', sm: '400px' },
              width: '100%',
              borderRadius: 3,
              boxShadow: '0 4px 32px rgba(0,0,0,0.1)',
              bgcolor: 'common.white',
              border: 0,
            },
          }}
        >
          <Box p={2} pb={1}>
            <Typography variant='h6' fontWeight={600}>
              Notifications ({notifications.length})
            </Typography>
          </Box>
          <Divider />

          <Box maxHeight={'320px'} overflow={'auto'}>
            {notifications.map((n) => (
              <Box
                key={n.id}
                display='flex'
                alignItems='flex-start'
                p={2}
                borderBottom='1px solid #eee'
                sx={{ '&:hover': { backgroundColor: '#f9f9f9' } }}
              >
                <Avatar
                  sx={{
                    bgcolor: '#E8F0FF',
                    color: '#1A73E8',
                    mr: 1.5,
                    width: 40,
                    height: 40,
                    fontSize: 18,
                  }}
                >
                  <IconSecAI color='#1E3A8A' />
                </Avatar>
                <Box flex={1}>
                  <Typography variant='body2' fontWeight={500}>
                    {n.title}
                  </Typography>
                  <Typography variant='caption' color='text.secondary' display='block' mt={0.5}>
                    {n.time}
                  </Typography>
                </Box>
                {n.unread && <CircleIcon color='error' sx={{ fontSize: 10, mt: 0.5 }} />}
              </Box>
            ))}
          </Box>

          <Divider />
          <Box display='flex' justifyContent='space-between' p={1.5}>
            <Button size='small' underline='underline'>
              Mark all as read
            </Button>
            <Button variant='contained' size='small'>
              View all Notifications
            </Button>
          </Box>
        </Popover>
      </Box>
    </>
  );
};

export default Notifications;
